import React from "react";
import AuthLayout from "./AuthLayout";
import { PasswordConfirmationFields, SubmitButton } from "./AuthFields";

const ResetPasswordPage = ({
  action,
  resetPasswordToken,
  tokenError,
  newUserSessionPath,
  showBackToSignIn
}) => (
  <AuthLayout
    action={action}
    method="put"
    formClassName="login-form"
    showBackToSignIn={showBackToSignIn}
    newUserSessionPath={newUserSessionPath}
  >
    {!tokenError && (
      <input type="hidden" name="user[reset_password_token]" value={resetPasswordToken} />
    )}
    <PasswordConfirmationFields
      passwordPlaceholder="Enter your new password"
      confirmationPlaceholder="Confirm your password"
      autoFocus
    />

    <div className="mtm">
      <SubmitButton value="Save Password" />
    </div>
  </AuthLayout>
);

export default ResetPasswordPage;
